<template>
<div class="headerStatistica">
    <div class="headerStatistica-data">
        <div :class="getStatusHeader.header.minimaze ? 'headerStatistica-item' : 'headerStatistica-item-minimaze'">
            <div :class="getStatusHeader.header.minimaze ? 'headerStatistica-subItem' : 'headerStatistica-subItem-minimaze'">
                    <div class="headerStatistica-subTitile">Открытых сделок</div>
                    <div class="headerStatistica-subData">{{statOpenPositions.count}}</div>
            </div>
            <transition enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut" mode="out-in">
                <div class="headerStatistica-subItem" v-show="getStatusHeader.header.minimaze">
                    <div class="headerStatistica-subTitile">% успешных сделок</div>
                    <div class="headerStatistica-subData"
                    :class = "(percentDeals < 50) ? 'color-red' : 'color-green'">98%</div>
                </div>
            </transition>
            <transition enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut" mode="out-in">
                <div class="headerStatistica-subItem" v-show="getStatusHeader.header.minimaze">
                    <div class="headerStatistica-subTitile">Пользователей ONLINE</div>
                    <!--<div class="headerStatistica-subData"
                        :class = "(statOpenPositions.percent < 50) ? 'color-red' : 'color-green'">{{Math.ceil(statOpenPositions.percent)}}%</div>-->
                    <counter></counter>
                </div>
            </transition>
        </div>
        <div :class="getStatusHeader.header.minimaze? 'headerStatistica-item' : 'headerStatistica-item-minimaze'">
            <div :class="getStatusHeader.header.minimaze ? 'headerStatistica-subItem' : 'headerStatistica-subItem-minimaze'">
                <div class="headerStatistica-subTitile">коэфф. шарпа</div>
                <div class="headerStatistica-subData">{{factorSharp}}</div>
            </div>
            <transition enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut" mode="out-in">
                <div class="headerStatistica-subItem" v-show="getStatusHeader.header.minimaze">
                    <div class="headerStatistica-subTitile">кредитное плечо</div>
                    <div class="headerStatistica-subData">{{brokerLeverage.toFixed(1)}}</div>
                </div>
            </transition>
            <transition enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut" mode="out-in">
                <div class="headerStatistica-subItem" v-show="getStatusHeader.header.minimaze">
                    <div class="headerStatistica-subTitile">Max. DD</div>
                    <div class="headerStatistica-subData color-red">6%</div>
                </div>
            </transition>
        </div>
    </div>
</div>
</template>
<script>
import { mapGetters } from "vuex";
import CounterOnlineUser from "./sig-user-counter";
export default {
    components : {
        'counter':CounterOnlineUser
    },
    data() {
        return {
        statistic: {},
        filterOpenPositions: [
            { field: "symbol", dir: "asc" },
            { field: "timeEnter", dir: "asc" }
        ],
        percentDeals:0,
        factorSharp:0,
        brokerLeverage:0,
        maxDD:0
        };
    },
    computed: {
        ...mapGetters({
            getStatistics: "accountstat/getStatistics",
            getStatusHeader:'usersets/getSettings'
        // positionsStat: 'positions/positionsFlatFiltered'
        }),
        statOpenPositions() {
            let flatStat = this.$store.getters["positions/positionsFlatFiltered"](this.filterOpenPositions);
            let countDeals = flatStat.length
            let sumProfitDeals = 0;
            for (let i = 0; i < flatStat.length; i++)
                if(flatStat[i].resultDepo > 0)
                    sumProfitDeals += 1;
            let percentProfitdeals = sumProfitDeals / (countDeals / 100)
            let dataOpenPositions = {}
            return dataOpenPositions = { count:countDeals, percent: percentProfitdeals };
        }
    },
    methods: {
        updateStatistics(symbol) {
            if (!symbol) symbol = this.symbol;
                let stat = this.getStatistics(symbol);
            if (!stat) {
                return;
            }
            this.statistic = stat;
            let profitDeals = (stat.Summary.ProfitableDeals / (stat.Summary.TotalDeals / 100)).toFixed()
            this.percentDeals = profitDeals;
            this.factorSharp = stat.Summary.Sharp1000;
            this.brokerLeverage = stat.DailyRecords[stat.DailyRecords.length - 1].Leverage;
            this.maxDD = stat.Summary.Drawdown1000
        }
    },
    created() {
        subscribeOnUpdate(this.$store, "", isFirstObtained => {
            if (!this.symbol || !this.symbol.length) {
                this.updateStatistics();
            }
            this.updateStatistics();
        });
    }
    };

function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
        id: "header-statistic",
        handler: handler
        }
    });
}
</script>
<style lang="less" scoped>
.headerStatistica {
  display: flex;
  flex-direction: column;
  background: #3d536b;
  margin-right: 0px;
  flex-grow: 1;
  height: 88px;
  box-sizing: border-box;
  &-title {
    font-family: Arimo;
    font-size: 10px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 3.2;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #ffffff;
    padding-left: 12px;
  }
  &-data {
    display: flex;
    max-width: 371px;
  }

  &-item {
    width: 185px;
    border-right: solid 1px #374b62;
     &:last-child {
       border-right:none; 
    }
    &-minimaze {
        width: 185px;
        height: 40px;
        //border-right: solid 1px #374b62;
        align-items: center;
    }
  }
  &-subItem {
    padding: 0 12px;
    display: flex;
    width: 100%;
    justify-content:space-between;
    border-top:solid 1px #374b62;
    box-sizing: border-box;
    &-minimaze {
        padding: 0 12px;
        display: flex;
        width: 100%;
        justify-content:space-between;
        align-items: center;
        height: 40px;
        border-top:none;
        box-sizing: border-box;
    }
  }
  &-subTitile {
    font-family: Arimo;
    font-size: 10px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.8;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #adc4e1;
  }
  &-subData
  {
      font-family: Arimo;
  font-size: 13px;
  //font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.15;
  letter-spacing: 0.4px;
  }
}
</style>
